import React from 'react';

import Typography from '../../library/typography/typography';

import { useMyAccount } from '../../shared/hooks/hooks';

import { formatCurrency } from '../../shared/utils/format/format';

import { MarkDownPriceType } from '../../shared/types/graphql-types';

import './markdown-price.scss';

interface MarkdownPriceProps {
  className?: string;
  markDownPriceType?: string | null;
  originalPrice?: number | null;
  percentageSaved?: string | null;
}

function MarkdownPrice(props: MarkdownPriceProps) {
  const { className, markDownPriceType, originalPrice, percentageSaved } =
    props;

  const { isFleetAccount } = useMyAccount();

  if (isNaN(Number(originalPrice)) && !percentageSaved) return null;

  return (
    <div className={className} styleName="markdown">
      {originalPrice && (
        <Typography styleName="original-price" tag="span">
          {formatCurrency(originalPrice)}
        </Typography>
      )}
      {percentageSaved && (
        <Typography
          size="extraSmall"
          styleName="percentage-saved"
          tag="span"
          weight="black"
        >
          {process.env.__FF_FLEET_ACCOUNT__ === 'true' &&
          isFleetAccount &&
          markDownPriceType === MarkDownPriceType.Fleet
            ? 'Fleet Discount'
            : 'Save'}
          &nbsp;{percentageSaved}
        </Typography>
      )}
    </div>
  );
}

export default MarkdownPrice;
